<app-menu>
    <div class="body" style="height:600px; width:100%;">
        <div class="button-div">
            <button mat-raised-button (click)="openAddTechnicianModal()">Add Technician</button>
            <!-- <button mat-raised-button>Add Technician Provider</button> -->
        </div>
        <div class="grid-section">
            <h2>Technicians</h2>
            <ag-grid-angular 
            #agGrid
            style="width:100%; height:300px"
            [rowData]="rowData" 
            [columnDefs]="colDefs"
            [class]="theme"
            (gridReady)="onGridReady($event)"
            (cellValueChanged)="onCellValueChanged($event)"
            ></ag-grid-angular>
        </div>
        <div class="grid-section">
            <h2>Technician Providers</h2>
            <ag-grid-angular 
            #agGridProvider
            style="width:100%; height:300px"
            [rowData]="providerRowData" 
            [columnDefs]="providerColDefs"
            [class]="theme"
            (gridReady)="onProviderGridReady($event)"
            (cellValueChanged)="onProviderCellValueChanged($event)"
            ></ag-grid-angular>
        </div>
    </div>
</app-menu>